module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "xmly-masker"
  }, [_c('div', {
    staticClass: "xmly-pop"
  }, [_c('div', {
    staticClass: "title-panel"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('span', {
    staticClass: "name elli"
  }, [_vm._v(_vm._s(_vm.nickName))]), _vm._v(" 您好！")])]), _vm._v(" "), _c('h2', {
    staticClass: "choose-tit"
  }, [_vm._v(_vm._s(_vm.role ? '请选择您需要的账号角色' : '您的账号没有角色'))]), _vm._v(" "), _c('ul', {
    staticClass: "xmly-account-list"
  }, _vm._l((_vm.accounts), function(account) {
    return _c('li', {
      key: account.id,
      staticClass: "xmly-account-item",
      on: {
        "click": function($event) {
          _vm.chooseRole(account.id)
        }
      }
    }, [_c('a', [_c('div', {
      staticClass: "arrow"
    }), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('div', {
      staticClass: "xmly-account-info elli"
    }, [_c('label', [_vm._v("区域：")]), _vm._v(_vm._s(account.provinceName + account.cityName + account.areaNames))]), _vm._v(" "), _c('div', {
      staticClass: "xmly-account-info elli"
    }, [_c('label', [_vm._v("身份：")]), _vm._v(_vm._s(account.promotorType == 1 ? '城市合伙人' : '分销商'))]), _vm._v(" "), _c('div', {
      staticClass: "xmly-account-info elli"
    }, [_c('label', [_vm._v("登录时间：")]), _vm._v(_vm._s(_vm.format(account.lastLoginAt) + ' 登录过'))])])])])
  })), _vm._v(" "), _c('el-button', {
    staticClass: "xmly-account-logout",
    attrs: {
      "type": "default"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("切换账号")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pic"
  }, [_c('img', {
    attrs: {
      "src": "http://fdfs.xmcdn.com/group31/M03/1E/C4/wKgJSVmBaJ-CjgQUAAOU3Y8Z6M8121_mobile_medium.jpg",
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e31c780","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/account/index.vue
// module id = 938
// module chunks = 1